// extracted by mini-css-extract-plugin
module.exports = {"root":"CancelAttendanceOrClass_root__3LjNH","cancelAttendanceButton":"CancelAttendanceOrClass_cancelAttendanceButton__uHBVm"};